export const GRP_BASEURL_PRELIVE = "https://grp-prelive.volkswagenag.com";
export const GRP_BASEURL_PROD = "https://grp.volkswagenag.com";

export const GRP_ROLE_ADMIN = 8;

// HRIN Roles
export const GRP_ROLE_HRIN_READ = 1001;
export const GRP_ROLE_HRIN_WRITE = 1002;
export const GRP_ROLE_HRIN_ADMIN = 1003;

// Whitelist of authorized roles for the HRIN module
export const GRP_ROLES_HRIN = [
  GRP_ROLE_HRIN_READ,
  GRP_ROLE_HRIN_WRITE,
  GRP_ROLE_HRIN_ADMIN,
  GRP_ROLE_ADMIN,
];
